import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CoverSection from "./components/CoverSection";
import TopicWall from "./components/TopicWall";
import StreetFeed from "./components/StreetFeed";
import CompareSection from "./components/CompareSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50 font-sans text-foreground-950">
      <Navbar />
      <Hero />
      <CoverSection />
      <TopicWall />
      <StreetFeed />
      <CompareSection />
      <FaqSection />
      <Footer />
    </main>
  );
}